export default __webpack_public_path__ + "static/media/change-room.01bfd32f.mp3";